import React from 'react';

import Button from '../../Button';
import Paragraph from '../../Paragraph';

const RegisterModal = (props) => {
  const { closePopup, showMap, goToRegistration, classes } = props;

  return (
    <div className={['modal-overlay', classes && classes].join(' ')}>
      <div className="modal-container">
        <button className="modal-close" onClick={closePopup}><span className="close-icon" /></button>

        <div className="modal-content">
          <Paragraph classes="logo-image" center><img src="/site/images/campaign/full-logo.svg" alt="flower" /></Paragraph>
          <div className="register-detail">
            <Paragraph classes="header-text" center>Here for you ...</Paragraph>
            <Paragraph classes="popup-text" center>We{"'"}re a FREE service helping Dorset to make healthy lifestyle changes. Are you ready to make a change? Register today to discover how we can help you take your next step to LiveWell.</Paragraph>
            <Button classes={['color-button orange']} label="Register now" onClick={goToRegistration} />
          </div>
          <div className="client-detail">
            <Paragraph classes="header-text" center>Our clients</Paragraph>
            <Paragraph classes="popup-text" center>We{"'"}ve supported over 25,000 people so far. See how we{"'"}ve helped your neighbourhood. Note this data is based only on people we{"'"}ve helped, not everyone in Dorset.</Paragraph>
            <Button classes={['color-button black']} label="Ok, Show me the map" onClick={showMap} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegisterModal;



// WEBPACK FOOTER //
// ./src/Components/Campaign/FormPages/RegisterModal.jsx